import { MatDialogRef } from '@angular/material/dialog';
import type { ExportDialogComponent } from '../../ui-kit/export-dialog/export-dialog.component';
import type { ExportType } from '../../store';

export interface ExportFileFacade {
  startExportToFile(
    reportName: string,
    dialogRef: MatDialogRef<ExportDialogComponent>,
    navigationNeeded: boolean,
    addressExport?: string,
    reportType?: ExportType,
  ): void;
}
